import { configureStore } from '@reduxjs/toolkit'
import { logger } from 'redux-logger'

import appReducer from './slices/'
// import { sentryReduxEnhancer } from 'services/sentry'

export default function configureAppStore(initialState = {}) {
  const middlewares =
    import.meta.env.VITE_REACT_APP_ENV === 'test' ? [] : [logger]

  const store = configureStore({
    reducer: appReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(middlewares),
    preloadedState: initialState,
    devTools: import.meta.env.VITE_REACT_APP_ENV !== 'production'
    // enhancers removed since it was empty - in RTK 2.0 enhancers must be a callback:
    // enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(additionalEnhancers)
  })

  return store
}

export const store = configureAppStore()
